import { TODO } from '@b2b/types/core/utils';
import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { ProgramsCalendarView } from './calendar/calendar';
import { ProgramsDetailView } from './detail/detail';
import { ProgramsInstanceView } from './instance/instance';
import { ProgramsListView } from './list/list';

export const ProgramsView = angular
  .module('acme.view.application.programs', [
    uiRouter,
    'ui.bootstrap',
    'isteven-multi-select',
    'acme.common.service.api',
    'acme.common.service.helpers',
    'acme.view.application.programs.controllers',
    ProgramsDetailView,
    ProgramsInstanceView,
    ProgramsCalendarView,
    ProgramsListView,
    'acme.view.application.programs.combos',
    'acme.view.application.dataGrid.controllers',
  ])
  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'application.programs',
      url: '/programs',
      abstract: true,
      views: {
        'subview-main': {
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/programs/programs.tpl.html',
        },
      },
      data: {
        pageTitle: 'Events',
      },
    });

    $stateProvider.state({
      name: 'application.programs.templatesList',
      url: '?type',
      views: {
        'subview-main': {
          controller: 'ProgramsController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/programs/programsTemplatesList.tpl.html',
        },
      },
      data: {
        pageTitle: 'Event Templates',
        permissions: ['EVENT_TEMPLATE_VIEW'],
        roles: ['admin'],
        enablePreferences: true,
      },
      resolve: {
        CustomFieldsData: [
          'ApiService',
          'HelpersService',
          function (ApiService: TODO, HelpersService) {
            return ApiService.customFields.list(HelpersService.getPaginator());
          },
        ],
      },
    });
  }).name;
